Ext.define('SA.controller.NewProjectController', {
    alias: 'controller.new-project-controller',

    constructor(cfg) {
        this.project = (cfg && cfg.project) || SA.data.Projects.createEmpty();

        this.showLocationsWindow();

        SA.LocationsReferenceTracker.registerReferencer(this);
    },

    destroy() {
        SA.LocationsReferenceTracker.unregisterReferencer(this);

        this.locations = null;
        this.project = null;

        Ext.destroy(this.locationsWin, this.variablesWin);

        this.locationsWin = null;
        this.variablesWin = null;
    },

    getReferencedLocations() {
        return Ext.Array.from(this.locations);
    },

    onCloseClick() {
        if (SA.data.Projects.hasMultipleProjects()) {
            SA.data.Projects.delete(this.project);
        }

        this.destroy();
    },

    onLocationSelectionDone(countryCode, locations) {
        var project = this.project,
            countryChanged = project.getCountry() !== countryCode,
            variables = SA.data.NewProjectAttributes.get(countryCode);

        if (countryChanged) {
            SA.data.Projects.delete(project);

            project = this.project = SA.data.Projects.createEmpty();
            project.setCountry(countryCode);

            if (SA.data.Projects.hasSingleProject()) {
                SA.AppController.openProject(project);
            }
        }

        this.locations = locations;

        this.showVariablesWindow(variables);

        this.locationsWin.destroy();
    },

    onVariableSelectionDone(attributes) {
        var project = this.project,
            locations = this.locations,
            mapView;

        project.addLocations(locations);
        project.addAttributes(attributes);
        project.autoCreateViews(['comparison', 'map', 'ranking', 'quickReport']);
        project.save();

        mapView = project.getAnyMapView();

        if (mapView) {
            SA.AppController.showProjectView(mapView);
        }
        else {
            SA.AppController.showProjectView(project, 'edit');
        }

        SA.data.RecentLocations.add(project.getLocations());
        SA.data.RecentAttributes.add(project.getAttributes());

        this.destroy();
    },

    showLocationsWindow() {
        var project = this.project;

        this.locationsWin = Ext.widget({
            xtype: 'new-project-locations-window',
            project,

            listeners: {
                scope: this,

                'click:close': this.onCloseClick,
                'done': this.onLocationSelectionDone
            }
        });
    },

    showVariablesWindow(variables) {
        var isCanada = this.project.getCountry() === 'CAN';

        this.variablesWin = Ext.widget({
            xtype: 'new-project-variables-window',
            variables,
            wide: isCanada, 

            listeners: {
                scope: this,

                'click:close': this.onCloseClick,
                'done': this.onVariableSelectionDone
            }
        });
    }
});